module.exports = __webpack_public_path__ + "media/2.22e7813c.wav";